import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FileFlatNode } from '../model/site-tree.model';
import { isDefined } from '../../../../../../../utils/utils';

@Component({
  selector: 'app-form-field-site-tree-toolbar',
  templateUrl: './site-tree-toolbar.html',
  styleUrls: ['./site-tree-toolbar.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SiteTreeToolbarComponent implements OnInit, OnDestroy {
  @Input() node: FileFlatNode;

  @Input() activeNode: FileFlatNode;

  @Input() hoveredNode: FileFlatNode;

  @Input() expanded: boolean;

  @Input() hasChildren: boolean;

  @Output() onNodeSelected: EventEmitter<FileFlatNode> = new EventEmitter<FileFlatNode>();

  @Output() onDelete: EventEmitter<FileFlatNode> = new EventEmitter<FileFlatNode>();

  @Output() onEdit: EventEmitter<FileFlatNode> = new EventEmitter<FileFlatNode>();

  @Output() onNew: EventEmitter<FileFlatNode> = new EventEmitter<FileFlatNode>();

  loaded: boolean = false;

  ngOnInit() {
    this.loaded = true;
  }

  ngOnDestroy() {}

  onClickOnNode(node: FileFlatNode) {
    this.onNodeSelected.emit(node);
  }

  onNodeToggle(node: FileFlatNode) {
    this.onNodeSelected.emit(node);
  }

  onDeleteClicked(node: FileFlatNode) {
    this.onDelete.emit(node);
  }

  onNewClicked(node: FileFlatNode) {
    this.onNew.emit(node);
  }

  onEditClicked(node: FileFlatNode) {
    this.onEdit.emit(node);
  }
}
